import React, { useEffect, useContext } from "react";
import ErrorBoundary from "../components/errorBoundary";
import ChampionshipBar from "../components/championshipBar";
import Leaderboard from "../components/leaderboards/leaderboard";
import { History } from "history";
import withRedux from "../withRedux";
import { RootState } from "../reducers";
import { getMyChampionships, loadLeaderboardFirstPage } from "../actions";
import { Championship, LeaderboardData } from "../types";
import UserContext from "../contexts/userContext";

type Props = {
	loadLeaderboardFirstPage;
	getMyChampionships;
	match;
	history: History;
	firstPage: LeaderboardData[];
};

const Leaderboards = ({ getMyChampionships, loadLeaderboardFirstPage, match, history, firstPage }: Props) => {
	const { profile } = useContext(UserContext);

	useEffect(() => {
		if (!match.params.id) {
			getMyChampionships()
				.then((championships: Championship[]) => {
					if (championships.length > 0) {
						history.push(`/championship/${championships[0].uuid}`);
					}
				})
				.catch(err => {
					console.log(err);
					//window.location.reload();
				});
		}
	}, [match.params.id]);

	return (
		<div className="leaderboardsPage">
			<ErrorBoundary>
				<ChampionshipBar compact={true} />
				{match.params.id && <Leaderboard uuid={match.params.id} firstPage={firstPage} profile={profile} />}
			</ErrorBoundary>
		</div>
	);
};

export default withRedux(
	{ getMyChampionships, loadLeaderboardFirstPage },
	({ championships: { championships, firstPages } }: RootState, { match }: Props) => {
		let firstPage = [];
		if (match.params.id) {
			const uuid = match.params.id;
			if (firstPages[uuid]) {
				firstPage = firstPages[uuid];
			}
		}

		return { championships, firstPage };
	}
)(Leaderboards);
